
























import Vue, { PropType } from 'vue';
import DropdownIndicator from '../../dropdowns/basics/DropdownIndicator/DropdownIndicator.vue';
import InputWrapper from '../bases/InputWrapper/InputWrapper.vue';
import MultiSelectDropdown from '../../dropdowns/basics/MultiSelectDropdown/MultiSelectDropdown.vue';
import BaseFormElem from '../bases/BaseFormElem.vue';

const ICON_ACTIVE = 'arrow-up-bold';
const ICON_INACTIVE = 'arrow-down';

interface OptionObject {
  label: string;
  value: string;
  disabled?: boolean;
}

export default Vue.extend({
  name: 'MultiSelectInput',
  extends: BaseFormElem,
  components: {
    MultiSelectDropdown,
    DropdownIndicator,
    InputWrapper,
  },
  props: {
    value: {
      type: Array as PropType<string[]>,
      default: () => ([]),
    },
    placeholder: {
      type: String,
      default: 'please select',
    },
    options: Array as PropType<string[] | OptionObject[]>,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeIcon: ICON_ACTIVE,
      inactiveIcon: ICON_INACTIVE,
    };
  },
  methods: {
    handleInput(value: any) {
      this.$emit('input', value.map((cur: any) => cur.value));
    },
    match(target: any, searchText: string) {
      return target.label.includes(searchText);
    },
  },
  computed: {
    indicatorText(): string {
      if (this.normalizedValue && this.normalizedValue.length > 0) {
        return this.normalizedValue
          .map((cur: any) => cur.label)
          .join(', ');
      }
      return '';
    },
    normalizedOptions(): OptionObject[] {
      if (this.options && Array.isArray(this.options) && this.options.length > 0) {
        if (typeof(this.options[0]) === 'object') {
          return this.options as OptionObject[];
        } else if (typeof(this.options[0]) === 'string') {
          return (this.options as string[]).map((cur)=> {
            return {
              label: cur,
              value: cur,
            };
          });
        }
      }
      return [];
    },
    normalizedValue(): OptionObject[] {
      if (this.value && this.value.length > 0) {
        return this.value.map((cur: any) => {
          return this.normalizedOptions.find((option) => {
            return option.value === cur;
          })!;
        }).filter((cur) => {
          return cur;
        });
      }
      return [];
    },
  },
});
